/**
 * Transform video source object to a video element
 *
 * @param  {Object} videoSource
 * @return {HTMLDivElement}
 */
export default (videoSource, posterSource) => {
  const videoElement = document.createElement('video');
  const sourceElement = document.createElement('source');

  sourceElement.type = 'video/mp4';
  sourceElement.src = videoSource.url;

  if (posterSource) {
    videoElement.setAttribute('poster', posterSource.url);
  }

  videoElement.appendChild(sourceElement);

  videoElement.muted = true;
  videoElement.loop = true;
  videoElement.setAttribute('playsinline', '');

  videoElement.className = 'home-video__element';

  return videoElement;
};
